import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ICommendaProduct } from './types';

export function useSalesTaxProduct({
  token,
  productId,
  corporationId,
}: {
  token: string;
  productId: string;
  corporationId: number;
}) {
  const {
    data,
    mutate,
    error,
  }: {
    data?: {
      data: ICommendaProduct;
    };
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/products/${productId}/corporation/${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: {
      productData: data?.data,
    },
    mutate,
    error,
  };
}
